import { IconArrowLeft } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { api, type Lang, type PrivacyNotice } from "../api";
import { ErrorNote, Spinner } from "../components/ui";
import { LANG_NAMES, LANGS } from "../i18n";
import { useSession } from "../session";

/** The privacy notice (docs/16 §6, decision 4): public, in the app's language; the switch here changes the whole app's language. */
export function PrivacyPage() {
  const { me, lang, setLang, t } = useSession();
  const [notice, setNotice] = useState<PrivacyNotice | undefined>(undefined);
  const [error, setError] = useState<string | null>(null);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let alive = true;
    setError(null);
    api
      .privacy(lang)
      .then((res) => {
        if (alive) setNotice(res);
      })
      .catch(() => {
        if (alive) setError(t("somethingWrong"));
      });
    return () => {
      alive = false;
    };
  }, [lang, tick, t]);

  const languages = notice?.languages.filter((l): l is Lang => (LANGS as string[]).includes(l)) ?? LANGS;

  return (
    <main className="page page-privacy">
      <a href={me ? "/account" : "/signin"} className="link-button back-link">
        <IconArrowLeft size={16} /> {t("back")}
      </a>
      <div className="privacy-head">
        <h1>{notice?.title ?? t("privacy")}</h1>
        <label className="lang-select">
          <span className="muted small">{t("language")}</span>
          <select value={lang} onChange={(e) => setLang(e.target.value as Lang)}>
            {languages.map((l) => (
              <option key={l} value={l}>
                {LANG_NAMES[l]}
              </option>
            ))}
          </select>
        </label>
      </div>
      {notice && <p className="muted small">{t("privacyVersion", { version: notice.version, controller: notice.controller })}</p>}
      {error ? (
        <ErrorNote onRetry={() => setTick((n) => n + 1)}>{error}</ErrorNote>
      ) : !notice ? (
        <Spinner />
      ) : (
        <div className="stack">
          {notice.sections.map((s) => (
            <section key={s.heading} className="card privacy-section">
              <h2>{s.heading}</h2>
              <p>{s.text}</p>
            </section>
          ))}
        </div>
      )}
    </main>
  );
}
